import { drawerWidth, drawerMiniWidth, transition, containerFluid } from '../../material-dashboard-pro-react.jsx';

const appStyle = (theme) => ({
  wrapper: {
    position: 'relative',
    top: '0',
    height: '100vh',
    '&:after': {
      display: 'table',
      clear: 'both',
      content: '" "',
    },
  },
  mainPanel: {
    transitionProperty: 'top, bottom, width',
    transitionDuration: '.2s, .2s, .35s',
    transitionTimingFunction: 'linear, linear, ease',
    overflow: 'auto',
    position: 'relative',
    float: 'right',
    ...transition,
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
    '& .MuiFilledInput-input': {
      minWidth: '10em',
    },
    '& a': {
      color: 'inherit',
    },
  },
  container: {
    ...containerFluid,
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: '100vh',
    display: 'flex',
  },
  content: {
    paddingTop: '64px',
    height: '100vh',
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      paddingLeft: `${drawerWidth}px`,
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: '56px',
    },
  },
  map: {
    marginTop: '70px',
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  },
});

export default appStyle;
